const $sectionTextImage = $(".section__text .text-content p img");

if($sectionTextImage.length > 0) {
    // Add aspect ratio class to inline images
    $sectionTextImage.each((i, e) => {
        e.parentNode.classList.add("img");
    });
}